import { render } from "./CaseBuddyForDevving.vue?vue&type=template&id=4cadc1e0&scoped=true"
import script from "./CaseBuddyForDevving.vue?vue&type=script&lang=js"
export * from "./CaseBuddyForDevving.vue?vue&type=script&lang=js"

import "./CaseBuddyForDevving.vue?vue&type=style&index=0&id=4cadc1e0&scoped=true&lang=css"
import "../assets/css/case-buddy.css?vue&type=style&index=1&id=4cadc1e0&scoped=true&lang=css&external"
import "./CaseBuddyForDevving.vue?vue&type=style&index=2&id=4cadc1e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cadc1e0"]])

export default __exports__